"use client";

import { createContext, useContext } from "react";
import type { AdContext } from "./types";

const AdCtx = createContext<AdContext | null>(null);

export function AdContextProvider({
    children,
    value,
}: {
    children: React.ReactNode;
    value: AdContext;
}) {
    return <AdCtx.Provider value={value}>{children}</AdCtx.Provider>;
}

export function useAdContext(): AdContext | null {
    return useContext(AdCtx);
}
